module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/main/main.component.scss
// module id = ./src/app/routes/main/main.component.scss
// module chunks = 9